import { render, staticRenderFns } from "./item.vue?vue&type=template&id=5da80438"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports